import { z } from 'zod';
import type {
  UnmatchInboundReceiptOfficialSettlementRequest,
  UnmatchInboundReceiptOfficialSettlementResponse,
} from './unmatch-inbound-receipt-official-settlement.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';

export const UnmatchInboundReceiptOfficialSettlementRequestSchema: z.ZodType<UnmatchInboundReceiptOfficialSettlementRequest> =
  z
    .object({
      companyId: z.uuid(),
      receiptId: z.uuid(),
      snapshotId: z.uuid(),
      reason: z.string().trim().min(1),
    })
    .strict();

export const UnmatchInboundReceiptOfficialSettlementResponseSchema: z.ZodType<UnmatchInboundReceiptOfficialSettlementResponse> =
  z
    .object({
      receipt: InboundReceiptDetailDtoSchema,
      deactivatedSnapshotId: z.uuid(),
    })
    .strict();
